import { RbidosRequestStatuses, SubmitFormType } from 'Pages/registratorCabinet'
import { FieldNames } from 'Constants/FieldNames'
import { FormNavigationItem } from 'LibNeo'

export enum PanelRadioOptions {
	QR_CODE = 'qr-code',
	SMS = 'sms',
}

export enum AllowedButtons {
	VIEW_PASSPORT = 'view_passport',
	SAVE = 'save',
}

export const radioOptions = [
	{
		label: 'Через QR-код',
		value: PanelRadioOptions.QR_CODE,
		key: PanelRadioOptions.QR_CODE,
	},
	{
		label: 'Через СМС',
		value: PanelRadioOptions.SMS,
		key: PanelRadioOptions.SMS,
	},
]

export type SubmitForm = (
	type: SubmitFormType,
	code?: string,
	need_sms?: boolean,
	isQrCodeForSbol?: boolean
) => void

export type NavItems = FormNavigationItem & { requiredEmptyFields?: FieldNames[] }

export enum BlockKeys {
	CLIENT_DATA,
	ORGANIZATION,
	PAY_PRODUCT,
	CHECKING_ACCOUNT,
	RESERVE,
	ADDITIONAL_PRODUCTS,
	INFOTECS,
	FNS,
}

export const outlinePushArray = [
	RbidosRequestStatuses.S_CBOL_CODE_ACCEPTED,
	RbidosRequestStatuses.S_PUSH_DOCS_ACCEPTED,
	RbidosRequestStatuses.S_COMPANY_SENT,
	RbidosRequestStatuses.S_DOCS_SENT,
	RbidosRequestStatuses.S_DOCS_GENERATED,
	RbidosRequestStatuses.S_CREATED,
]

export const translateBlockName = {
	[BlockKeys.CLIENT_DATA]: 'Данные клиента',
	[BlockKeys.ORGANIZATION]: 'Сведения об организации',
	[BlockKeys.PAY_PRODUCT]: 'Оплата услуги',
	[BlockKeys.CHECKING_ACCOUNT]: 'Расчетный счет в Сбербанке',
	[BlockKeys.RESERVE]: 'Резервирование счета',
	[BlockKeys.ADDITIONAL_PRODUCTS]: 'Дополнительные продукты',
	[BlockKeys.INFOTECS]: 'Очная идентификация',
	[BlockKeys.FNS]: 'Документы ФНС',
}

export const initialNavList = Object.keys(translateBlockName)

export const fieldsByFormBlock = {
	[BlockKeys.CLIENT_DATA]: [
		FieldNames.LAST_NAME,
		FieldNames.FIRST_NAME,
		FieldNames.MIDDLE_NAME,
		FieldNames.GENDER,
		FieldNames.BIRTH_DATE,
		FieldNames.BIRTH_PLACE,
		FieldNames.PASSPORT_SERIES,
		FieldNames.PASSPORT_NUMBER,
		FieldNames.PASSPORT_GIVEN_DATE,
		FieldNames.PASSPORT_GIVEN_BY,
		FieldNames.PASSPORT_GIVEN_DEPT,
		FieldNames.SNILS,
		FieldNames.INN,
		FieldNames.PHONE,
		FieldNames.EMAIL,
		FieldNames.ADDRESS,
		FieldNames.PASSPORT_FULL,
		FieldNames.USER_PASSPORT_MAINS,
		FieldNames.USER_PASSPORT_REGISTRATION,
		FieldNames.USER_PASSPORT_FULLS,
	],
	[BlockKeys.ORGANIZATION]: [
		FieldNames.ORG_NAME,
		FieldNames.ORG_SHORT_NAME,
		FieldNames.AUTHORIZED_CAPITAL_SIZE,
		FieldNames.OWN_USTAV,
		FieldNames.CONTACT_PHONE,
		FieldNames.EMAIL_FOR_DOCS,
		FieldNames.IS_INTERNATIONAL_ORG_NAME,
		FieldNames.INTERNATIONAL_ORG_NAME,
		FieldNames.INTERNATIONAL_ORG_SHORT_NAME,
		FieldNames.SAME_ADDRESS,
		FieldNames.JURIDICAL_ADDRESS,
		FieldNames.SAME_POSTAL_ADDRESS,
		FieldNames.POSTAL_ADDRESS,
		FieldNames.SITE_PRESENT,
		FieldNames.SITE,
		FieldNames.POSITION_CUSTOMER,
		FieldNames.POSITION,
		FieldNames.CHIEF_POSITION_TIME_YEARS,
		FieldNames.TAXATION_SYSTEM,
		FieldNames.OKVED_ADDITIONALS_CODES,
		FieldNames.OKVED_MAIN_CODE,
		FieldNames.PACKAGE_OKVED,
		FieldNames.PRILOZH_DOCUMS,
		FieldNames.COVERING_LETTER,
		FieldNames.APPLY_GENERATED_DOCUMENT,
		FieldNames.FOUNDER_INFO,
		FieldNames.HIDE_FOUNDER_INFO,
	],
	[BlockKeys.PAY_PRODUCT]: [],
	[BlockKeys.CHECKING_ACCOUNT]: [
		FieldNames.ACTIVE,
		FieldNames.DIVISION,
		FieldNames.DIVISION_CODE,
		FieldNames.PUBLIC_OFFICIAL_MARK,
		FieldNames.EIO_MARK,
		FieldNames.POSITION_CUSTOMER,
		FieldNames.POSITION,
		FieldNames.ADRS_WORK,
		FieldNames.PAYMENT_PURPOSE_CONTRACT,
		FieldNames.PAYMENT_PURPOSE_CONTRACT_CUSTOM,
		FieldNames.ANOTHER_COUNTRY_TAXPAYER_MARK,
	],
	[BlockKeys.RESERVE]: [FieldNames.SBER_GEO_UNIT_CODE_NSI, FieldNames.DRS_SBER_GEO_UNIT],
	[BlockKeys.ADDITIONAL_PRODUCTS]: [
		FieldNames.EQUIP_TYPE,
		FieldNames.ONLINE_MANAGER_PRODUCT_IDS,
		FieldNames.PRODUCTS,
		FieldNames.PRODUCT_IDS,
		FieldNames.ONLINE_PRODUCT_IDS,
		FieldNames.PRODUCT_REQUEST_RELATION_RECOMMENDATIONS,
		FieldNames.RECOMMENDATION_PRODUCT_IDS,
		FieldNames.ADD_INFO,
		FieldNames.RATE,
		FieldNames.EQUIP_CONNECT_TYPE,
		FieldNames.EQUIP_AMOUNT,
		FieldNames.INSTALL_REGION_ID,
		FieldNames.POSADDRESS,
		FieldNames.SAME_POS_ADDRESS,
		FieldNames.POS_NAME,
		FieldNames.QUESTIONS_CONTACT_PHONE,
		FieldNames.MCC_GROUP_ID,
		FieldNames.MCC_CODE_ID,
		FieldNames.SAME_AS_CLIENT_DECISION_MAKER,
		FieldNames.DECISION_MAKER_PERSON_LAST_NAME,
		FieldNames.DECISION_MAKER_PERSON_FIRST_NAME,
		FieldNames.DECISION_MAKER_PERSON_MIDDLE_NAME,
		FieldNames.SAME_AS_CLIENT_FINANCE_PERSON,
		FieldNames.FINANCE_PERSON_NAME,
		FieldNames.FINANCE_PERSON_EMAIL,
		FieldNames.SAME_AS_CLIENT_MANAGER,
		FieldNames.MANAGER_LAST_NAME,
		FieldNames.MANAGER_FIRST_NAME,
		FieldNames.MANAGER_MIDDLE_NAME,
		FieldNames.MANAGER_PHONE,
		FieldNames.MANAGER_EMAIL,
	],
	[BlockKeys.INFOTECS]: [
		FieldNames.REGION,
		FieldNames.CITY,
		FieldNames.DATE,
		FieldNames.TIME,
		FieldNames.ADDRESS_DADATA,
	],
	[BlockKeys.FNS]: [],
}

export const CmVisitManagerFields: FieldNames[] = [
	FieldNames.SBER_GEO_UNIT_REGION,
	FieldNames.SBER_GEO_UNIT_TOWN_NAME,
]

export const Sber_Geo_Fields: FieldNames[] = [
	FieldNames.SBER_GEO_UNIT_CODE_NSI,
	FieldNames.DRS_SBER_GEO_UNIT,
]

export const RbidosBeforeReserveStatuses = [
	RbidosRequestStatuses.S_NEW,
	RbidosRequestStatuses.S_CREATED,
	RbidosRequestStatuses.S_REGISTERED,
	RbidosRequestStatuses.S_REQUEST_CREATED,
	RbidosRequestStatuses.S_DOCS_SENT,
]
